import { createFileRoute } from '@tanstack/react-router'

import { PaginaErrosSistema } from '@/features/erros-sistema/pagina'

export const Route = createFileRoute('/$perfil/erros')({
  // `?erro=` guarda qual erro está aberto no detalhe.
  validateSearch: (busca: Record<string, unknown>): { erro?: string } =>
    typeof busca.erro === 'string' && busca.erro ? { erro: busca.erro } : {},
  component: Tela,
})

function Tela() {
  return <PaginaErrosSistema />
}
